<script lang="ts">
  import * as Header from '$lib/components/header';
  import { Button } from '$lib/components/ui/button';
  import { Undo, Undo2, GraduationCap, Minus } from 'lucide-svelte';
  import { BackToTop } from './(components)';
  import LogoIcon from '$lib/components/LogoIcon.svelte';
  import { route } from '$lib/ROUTES';
</script>

<Header.Root sticky={false}>
  <Header.Content class="container">
    <Header.Left>
      <a href="/">
        <LogoIcon />
      </a>
      <span class="bg-muted-foreground/20 w-px h-6 my-auto mx-4" />
      <a
        href={route('/guides')}
        class="flex items-center gap-2 text-sm text-primary font-bold hover:underline"
      >
        <GraduationCap class="size-6" />
        Guides
      </a>
    </Header.Left>
    <Header.Right>
      <Button href="/" size="sm" variant="secondary">
        <Undo2 class="size-4 mr-2" />
        <span>Back to Account</span>
      </Button>
    </Header.Right>
  </Header.Content>
</Header.Root>

<div class="container">
  <slot />
</div>

<BackToTop />
